/*@ngInject*/
const ProductTemplateEditorModel = function () {

    var productTemplate = {},
        quoteTemplateFile,
        binderTemplateFile;

    this.hasUnsavedChanges = false;
    this.isValid = false;

    this.getProductTemplate = function() {
        return productTemplate;
    };

    this.setProductTemplate = function (template) {
        productTemplate = template;
    };

    this.getQuoteTemplateFile = function() {
        return quoteTemplateFile;
    };

    this.setQuoteTemplateFile = function (templateFile) {
        quoteTemplateFile = templateFile;
    };

    this.getBinderTemplateFile = function() {
        return binderTemplateFile;
    };

    this.setBinderTemplateFile = function (templateFile) {
        binderTemplateFile = templateFile;
    };



};

angular.module('ums.configuration')
    .service('productTemplateEditorModel', ProductTemplateEditorModel);
